export default "__VITE_ASSET__j44IoUql__"